import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { UserActivityCategory } from "model";
/**
* @class UserActivity
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.userActivities[0];
* const device = new UserActivity(record);
* @property {NUMBER} _id - The id of the userActivity.
* @property {BCMSDate} _date - The date of the userActivity.
* @property {String} _time - The time of the userActivity.
* @property {UserActivityCategory} _category - The category of the userActivity.
*/

export default class UserActivity extends BCMSRecord {
    _id
    _date
    _time
    _category
    
    constructor (record){     
      super( record  ) 
    }
  }
UserActivity.define({
    "recordType":"userActivities",
    "recordIDProp":"id",
    "className" : "UserActivity",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the userActivity
         * @property set {NUMBER} - sets the id of the userActivity
         * @memberof UserActivity
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name date
         * @instance
         * @property get {BCMSDate} - gets the date of the userActivity
         * @property set {BCMSDate} - sets the date of the userActivity
         * @memberof UserActivity
         */
        BCMSRecordProperty.mapToDate("date", "_date", "date"),

        /** 
         * @name time
         * @instance
         * @property get {STRING} - gets the time of the userActivity
         * @property set {STRING} - sets the time of the userActivity
         * @memberof UserActivity
         */
        BCMSRecordProperty.mapToString("time", "_time", "time"),

        /** 
         * @name category
         * @instance
         * @property get {STRING} - gets the category of the userActivity
         * @property set {STRING} - sets the category of the userActivity
         * @memberof UserActivity
         */
        BCMSRecordProperty.mapToClass("category", "_category", () => UserActivityCategory),
      ]
})




